/**
 * LES GESTES DE LA BARRE DE LOT, dans l'ordre, pour un mode d'ecran donne.
 *
 * FONCTION PURE, extraite de `BulkBar` pour pouvoir se tester sans DOM (le
 * runner de ce paquet est `node --test` sur `dist/`). Elle porte les deux
 * regles qui peuvent se tromper en silence :
 *
 * - EN MODE ARCHIVES, PLUS D'« ARCHIVER » : les fiches y sont deja. A sa place
 *   (meme position) vient « Désarchiver », qui restaure le lot.
 * - LE LIME DE « MODIFICATION GROUPEE » N'EXISTE QUE HORS MODE. Il est
 *   TRANSFERE depuis « + Ajouter » ; en mode Archives ou Modeles, « + Ajouter »
 *   est remplace par « Quitter ... » en secondaire, donc il n'y a aucun lime a
 *   transferer et l'ecran n'en porte aucun (G14).
 */

/** La cle d'un geste : elle designe la raison de `bulkAvailability` et le verbe. */
export type BulkGestureKey = 'edit' | 'archive' | 'unarchive' | 'remove';

export interface BulkGesture {
  key: BulkGestureKey;
  label: string;
  variant: 'primary' | 'secondary' | 'danger';
}

export function gestesDeLot(modes: { archivesMode: boolean; modelesMode: boolean }): BulkGesture[] {
  const dansUnMode = modes.archivesMode || modes.modelesMode;
  return [
    { key: 'edit', label: 'Modification groupée', variant: dansUnMode ? 'secondary' : 'primary' },
    modes.archivesMode
      ? { key: 'unarchive', label: 'Désarchiver', variant: 'secondary' }
      : { key: 'archive', label: 'Archiver', variant: 'secondary' },
    { key: 'remove', label: 'Supprimer', variant: 'danger' },
  ];
}
